import React, { useMemo } from 'react';
import { Grid } from '@mui/material';
import { KpiCard } from 'dashboard/components/common';

/**
 * Four KPI tiles at the top of the orders page: total, pending,
 * paid+fulfilled, realized revenue. Computed from the current rows
 * page — intentionally NOT from a separate aggregate API call, since
 * the brand owner is usually scanning the table they're looking at.
 */
export default function OrderKpiRow({ rows }) {
  const stats = useMemo(() => {
    const paid = rows.filter((r) => ['paid', 'fulfilled'].includes(r.status));
    const revenue = paid.reduce((a, r) => a + Number(r.grand_total || 0), 0);
    return {
      count: rows.length,
      pending: rows.filter((r) => r.status === 'pending').length,
      paid: paid.length,
      revenue,
    };
  }, [rows]);

  return (
    <Grid container spacing='12px'>
      <Grid item xs={6} md={3}><KpiCard label='All'              value={stats.count} /></Grid>
      <Grid item xs={6} md={3}><KpiCard label='Pending'          value={stats.pending} accent='#d97706' /></Grid>
      <Grid item xs={6} md={3}><KpiCard label='Paid + fulfilled' value={stats.paid}    accent='#16a34a' /></Grid>
      <Grid item xs={6} md={3}><KpiCard label='Realized revenue' value={stats.revenue.toFixed(2)} accent='#2563eb' /></Grid>
    </Grid>
  );
}
